export const ALLOWED_GAME_PLATS = ['PG', 'PGS'];

export const ALLOWED_JOKER_PLATS = [
  'BBQP',
  'BGQP',
  'KY',
  'LEG',
  'LY',
  'VG',
  'TM',
  'HLGAME',
  'HC',
  'KX',
  'XSJ',
  'DATQP',
  'SY',
];

export const ALLOWED_REALBET_PLATS = ['BGZR', 'DBZR', 'BBZR', 'BG'];

export const ALLOWED_GAME_CATEGORIES = ['joker', 'realbet'];

export function normalizeGamePlat(name) {
  return String(name || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/游戏|电子|SOFT/g, '');
}

function readStoredGameList(key) {
  try {
    const list = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

function isListedGame(storageKey, name, gameCode) {
  const plat = normalizeGamePlat(name);
  if (!plat) return false;
  const code = gameCode === undefined || gameCode === null ? '' : String(gameCode);
  return readStoredGameList(storageKey).some((item) => {
    if (normalizeGamePlat(item.platform_name) !== plat) return false;
    if (code === '') return true;
    return String(item.game_code) === code;
  });
}

export function isJokerListedGame(name, gameCode) {
  return isListedGame('jokerList', name, gameCode);
}

export function isRealbetListedGame(name, gameCode) {
  return isListedGame('realbetList', name, gameCode);
}

export function isAllowedGamePlat(name, category, gameCode) {
  const code = normalizeGamePlat(name);
  if (ALLOWED_GAME_PLATS.indexOf(code) !== -1) {
    return true;
  }
  const cat = String(category || '')
    .trim()
    .toLowerCase();
  if (ALLOWED_GAME_CATEGORIES.indexOf(cat) !== -1) {
    return true;
  }
  if (ALLOWED_JOKER_PLATS.indexOf(code) !== -1) {
    return true;
  }
  if (ALLOWED_REALBET_PLATS.indexOf(code) !== -1) {
    return true;
  }
  return isJokerListedGame(name, gameCode) || isRealbetListedGame(name, gameCode);
}

export function showGameNotOpen(vm) {
  if (!vm) return;
  const t = (key) => (typeof vm.$t === 'function' ? vm.$t(key) : key);
  const dialog = vm.$dialog || (vm.$parent && vm.$parent.$dialog);
  if (dialog && typeof dialog.alert === 'function') {
    dialog.alert({
      title: t('Tips'),
      message: t('Game not open'),
      confirmButtonText: t('Got it'),
    });
    return;
  }
  if (typeof vm.showTost === 'function') {
    vm.showTost(0, t('Game not open'));
    return;
  }
  if (vm.$parent && typeof vm.$parent.showTost === 'function') {
    vm.$parent.showTost(0, t('Game not open'));
  }
}



// WEBPACK FOOTER //
// ./src/utils/gameAccess.js